import React from 'react';
import classNames from 'classnames';
import { ILeftVsRightKeys, ITournamentMatchShotData } from 'twain-sport-fe-mono/interfaces';
import { generateScoresList } from './utils/generateScoresList';
import { ColorStyles } from '../enums/ColorStyles';
import classes from './ThermometerRow.module.scss';

interface IProps {
    scores: ITournamentMatchShotData[];
    length: number;
    side: ILeftVsRightKeys;
    historical?: boolean;
    colorStyle?: ColorStyles;
}

export const ThermometerRow: React.FC<IProps> = (props) => {
    const animate = React.useRef<boolean>(false);

    const scores = React.useMemo(() => {
        const generatedScores = generateScoresList(
            props.length,
            props.scores,
            animate.current,
            props.historical,
        );

        if (!animate.current) {
            animate.current = true;
        }

        return generatedScores;
    }, [props.scores, props.length]);

    return (
        <div className={classes.container}>
            {scores.map((score) => (
                <span
                    key={score.key}
                    className={classNames(
                        classes[props.colorStyle],
                        classes.cell,
                        score.fill ? classes.progressFill : classes.progressEmpty,
                        classes[props.side],
                        {
                            [classes.dot]:
                                score.isSuccessful || (!props.historical && score.current),
                            [classes.success]: score.isSuccessful,
                            [classes.current]: !props.historical && score.current,
                            [classes.animate]: score.animate,
                        },
                    )}
                />
            ))}
        </div>
    );
};
